export default {
  deforestation: {
    producerData: {
      addProducers: "NIEUWE PRODUCENT TOEVOEGEN",
      countryInfo:
        "Veld om het land in te voeren of weer te geven dat aan een producent is gekoppeld.",
    },
    selectFileToUpload: "Selecteer bestand om gegevens te uploaden",
    uploadedToEU: "Geüpload naar EU-portaal",
    pending: "In afwachting",
    underReview: "In beoordeling",
    compliant: "Conform",
    nonCompliant: "Niet-conform",
    analyzeDeforestation: "Ontbossing analyseren",
    readyToProceed: "Klaar om door te gaan",
    processingFarm: "Boerderij wordt verwerkt",
    mitigationRequired: "Mitigatie vereist",

    veryHighDeforestationProbability: "Zeer hoge kans op ontbossing",
    highDeforestationProbability: "Hoge kans op ontbossing",
    mediumDeforestationProbability: "Gemiddelde kans op ontbossing",
    lowDeforestationProbability: "Lage kans op ontbossing",
    veryLowDeforestationProbability: "Zeer lage kans op ontbossing",
    zeroNegligibleDeforestationProbability:
      "Nul/negligibele kans op ontbossing",
    manuallyMitigated: "Handmatig gemitigeerd",

    selectCountry: "Selecteer Land",
    internalReferenceNumberMustBeAlphanumeric:
      "Het interne referentienummer moet alfanumeriek zijn",
    atLeastOneOfSupplierIdOrSupplierNameIsRequired:
      "Minstens één van de velden Leveranciers-ID of Leveranciersnaam is vereist",
    atLeastOneOfOperatorIdOrOperatorNameIsRequired:
      "Minstens één van de velden Operator-ID of Operatornaam is vereist",
    netMassIsRequired: "De nettomassa is vereist",
    netMassMustBeValid: "De nettomassa moet geldig zijn",
    thisFieldIsRequired: "Dit veld is verplicht",
    volumeMustBeNumeric: "Het volume moet numeriek zijn",
    nameIsRequired: "De naam is verplicht",
    lastNameIsRequired: "De achternaam is verplicht",
    firstNameIsRequired: "De voornaam is verplicht",
    countryIsRequired: "Het land is verplicht",

    confirmPdfDownload: "Wilt u alle bijlagen in PDF-formaat downloaden?",
    confirmJsonDownload: "Wilt u alle bijlagen in JSON-formaat downloaden?",
    basicFinalFarmListWithStatus: "Basislijst van eindboerderijen met status",
    detailedInformationIncludingDescriptionOfRiskMitigationActivities:
      "Gedetailleerde informatie, inclusief de beschrijving van risicobeperkende activiteiten",
    completeDocumentIncludingRiskMitigationAndAttachedDocuments:
      "Volledig document, inclusief risicobeperking en bijgevoegde documenten",

    existing: "Bestaand",
    survey: "Enquête",

    operatorInformation: "Informatie over Operator",
    addNewOperator: "Een Nieuwe Operator Toevoegen",

    reportAddedSuccessfully: "Rapport succesvol toegevoegd",
    reportUpdatedSuccessfully: "Rapport succesvol bijgewerkt",
    itemDeletedSuccessfully: "Item succesvol verwijderd",
    reportDeletedSuccessfully: "Rapport succesvol verwijderd",
    anErrorOccurredWhileDeletingTheReport:
      "Er is een fout opgetreden bij het verwijderen van het rapport",

    valueMustBeBetween02And40: "De waarde moet tussen 0,2 en 40 liggen",

    EUDRDeforestationStatusTT:
      "Selectie van ontbossingsstatus. Hoge Kans op Ontbossing: Een specifieke risicobeoordelingscategorie toegewezen aan bepaalde geografische gebieden op basis van de kans op ontbossing of bosdegradatie. Dit helpt bij het bepalen van de due diligence-vereisten voor exploitanten die relevante grondstoffen (zoals cacao, koffie, enz.) of producten die ze bevatten of ermee zijn vervaardigd, op de EU-markt brengen. Lage Kans op Ontbossing: Een risicobeoordelingscategorie toegewezen aan geografische gebieden waarvan wordt aangenomen dat ze weinig kans hebben op aanzienlijke ontbossing of bosdegradatie. Deze aanduiding beïnvloedt de due diligence-vereisten voor exploitanten die producten of grondstoffen uit deze gebieden op de EU-markt brengen. Nul/Onbetekenende Kans op Ontbossing: Een zeer lage of niet-bestaande kans op ontbossing. Impliceert dat het risico of de impact van ontbossing als uiterst klein of onbeduidend wordt beschouwd.",

    complianceRiskWarnings: "Waarschuwingen voor nalevingsrisico",
    complianceRiskWarningsInfo:
      "Toont de sectietitel, die aangeeft dat dit gebied zich richt op waarschuwingen met betrekking tot nalevingsrisico's in het due diligence-proces.",
    locationVerificationTT:
      "Verwijst naar het proces van bevestiging en validatie van de geografische locatie van productieplaatsen als onderdeel van due diligence-procedures. Dit omvat ervoor zorgen dat de verstrekte locatiedetails, zoals coördinaten of adressen, nauwkeurig de fysieke locatie vertegenwoordigen waar productieactiviteiten plaatsvinden. Deze verificatie is cruciaal voor de beoordeling van milieueffecten, naleving van landgebruik en de nauwkeurigheid van de gerapporteerde gegevens in het due diligence-rapport.",
    netMassKg: "Nettomassa (kg)",
    volumeM3: "Volume (m3)",
    warning: "Waarschuwing",

    productionPlacesTT:
      "Locaties waar goederen worden geproduceerd of verbouwd.",
    productionPlacesCountryInfo:
      "Een afzonderlijk territoriaal lichaam met een eigen regering en grenzen.",
    productionPlacesProducersInfo:
      "Entiteit verantwoordelijk voor het creëren of kweken van goederen.",
    totalsTT:
      "De sectie 'Totalen' biedt een samenvatting van de belangrijkste kwantitatieve indicatoren voor de gehele dataset of het rapport. Het voegt gegevens samen om gebruikers een snel overzicht te geven van de algemene statistieken, zoals de totale massa van het product, het totale volume van het product, het oppervlaktegebied van de productielocatie, enz., betrokken bij het due diligence-rapport.",

    AnalysisOfDeforestationStatusTT:
      "De analyse van de huidige staat van ontbossing binnen een specifiek gebied, meestal uitgevoerd om milieueffecten of naleving van behoudsinspanningen te beoordelen.",

    complete: "Voltooid",

    undoDelete: "Verwijdering Ongedaan Maken",

    verifyingLocationsData: "Locatie(s) gegevens verifiëren...",
    crossCheckingWithProductionPlaces: "Kruiscontrole met productielocaties...",
    almostTherePleaseHoldOn: "Bijna klaar, even geduld alstublieft...",
    LocationVerifiedSuccessfully: "Locatie(s) succesvol geverifieerd!",
    allProductionPlacesAndLocationsHaveBeenConfirmed:
      "Alle productielocaties en locaties zijn bevestigd!",
    errorCheckingOverlaps: "Fout bij het controleren van overlappingen.",
    farmIsBiggerThan4HectaresItNeedsToBeAPolygon:
      "De boerderij is groter dan 4 hectare, het moet een polygoon zijn",
    failedToFetchSettings:
      "Instellingen kunnen niet worden opgehaald. Controleer uw instellingen of neem contact op met de ondersteuning als het probleem aanhoudt.",
    farmCountryNotDefined: "Boerderijland niet gedefinieerd.",
    theGeofencesSupposeToBeIn: "De geofence zou zich moeten bevinden in",
    butItsIn: "maar het is in",
    geofenceIsInOcean:
      "De geofence of een deel van de geofence bevindt zich in de oceaan.",

    existingReport: "Bestaand Ontbossingsrapport",
    dimitraReport: "Dimitra Ontbossingsrapport",
    oneForAllFarms: "Eén voor alle boerderijen",
    oneForEachFarm: "Eén voor elke boerderij",

    anErrorOccuredWhileFetchingTheDeforestationReport:
      "Er is een fout opgetreden bij het ophalen van het ontbossingsrapport.",

    attachRiskMigrationDocTT:
      "Geeft de actie aan om één enkel document te koppelen aan alle geïdentificeerde boerderijen met een ontbossingsrisico, meestal voor documentatie- of nalevingsdoeleinden.",
    approve: "Goedkeuren",
    conclude: "Conclusie",
    approveMessage:
      "Weet u zeker dat u dit rapport wilt goedkeuren? Door dit rapport goed te keuren, wordt het permanent geüpload naar de blockchain. Een blockchain-link en een QR-code worden gegenereerd, en er kunnen geen verdere updates of bewerkingen worden uitgevoerd. Wilt u doorgaan?",
    eudrComplianceStatus: "EUDR nalevingsstatus",
    deforestationComplianceReport: "Rapporten inzake ontbossingsnaleving",
    noDeforestationComplianceReport:
      "Geen rapport inzake ontbossingsnaleving gevonden",
    loadingDeforestationComplianceReport:
      "Rapport inzake ontbossingsnaleving laden",
    farmName: "Naam van de boerderij",
    farmRegistrationId: "Boerderijregistratie ID",
    farmerName: "Naam van de boer",
    farmerRegistrationId: "Boerenregistratie ID",
    uniqueFarmerId: "Unieke boer ID",
    uniqueFarmId: "Unieke boerderij ID",
    farmLocation: "Locatie van de boerderij",
    area: "Gebied",
    farmAddress: "Adres van de boerderij",
    dateOfRequest: "Aanvraagdatum",
    status: "Status",
    settings: "Instellingen",

    farmLatitude: "Breedtegraad van de boerderij",
    farmLongitude: "Lengtegraad van de boerderij",
    shareQRCode: "QR-code delen",
    copy: "Kopiëren",

    allCountries: "Alle landen",
    allRegions: "Alle regio's",
    allFarms: "Alle boerderijen",
    allProducer: "Alle producenten",
    viewCertificate: "Certificaat bekijken",

    assignmentIssued: "Opdracht uitgegeven",

    complianceCertification: "Nalevingscertificering",
    noComplianceCertification: "Geen nalevingscertificering gevonden",
    loadingComplianceCertification: "Nalevingscertificering laden",

    eudrForestAssessment: "EUDR bosbeoordelingen",
    assessmentReport: "Beoordelingsrapport",
    downloadPDF: "PDF downloaden",
    back: "Terug",
    farmDetails: "Boerderijgegevens",

    dimitraFarmId: "Dimitra boerderij ID",
    dimitraFermerId: "Dimitra boeren ID",

    totalGeofenceAreaHA: "Totale geofence oppervlakte (HA)",
    forestLossHA: "Bosverlies (HA)",
    forestGainHA: "Boswinst (HA)",
    forestUnchangedHA: "Bos ongewijzigd (HA)",
    shareCertificate: "Certificaat delen",
    forestUnchanged: "Bos ongewijzigd",
    forestLoss: "Bosverlies",
    forestGain: "Boswinst",
    totalGeofenceArea: "Totale geofence oppervlakte",
    deforestationProbability: "Ontbossingskans",
    colorCode: "Kleurcode",
    geofenceArea: "Geofence oppervlakte",
    percentageOfGeofenceArea: "Percentage van geofence oppervlakte",
    view: "Bekijken",
    customization: "Aanpassing",
    recordsPerpage: "Records per pagina",
    restoreDefault: "Standaard herstellen",
    apply: "Toepassen",
    forestAssessmentHelp:
      "Als u vragen heeft over dit rapport of hulp nodig heeft bij het begrijpen ervan, neem dan contact met ons op via de Helpdesk.",
    overallDeforestationProbability: "Algemene ontbossingskans",
    zeroOrNegligible: "Nul/verwaarloosbaar",
    high: "Hoog",
    allStatus: "Alle statussen",
    low: "Laag",
    veryHigh: "Zeer hoog",
    medium: "Gemiddeld",
    veryLow: "Zeer laag",
    assessmentIssued: "Beoordeling uitgegeven",
    certificateIssued: "Certificaat uitgegeven",
    assessmentNo: "Beoordelingsnummer",
    blockchainCertificateDesc:
      "Blockchain certificaat validatie hash zal beschikbaar zijn bij acceptatie van het certificaat",
    blockchainValidation: "Blockchain certificaat validatie",
    openBlockchainPage: "Blockchain pagina openen",
    clickLinkDesc:
      "Klik op bovenstaande link om het certificaat op de blockchain te valideren",
    "Zero/Negligible Deforestation Probability":
      "Nul/Verwaarloosbare Ontbossingskans",
    "Zero Deforestation Probability": "Nul Ontbossingskans",
    "Low Deforestation Probability": "Lage Ontbossingskans",
    "High Deforestation Probability": "Hoge Ontbossingskans",
    "Very Low Deforestation Probability": "Zeer Lage Ontbossingskans",
    "Medium Deforestation Probability": "Gemiddelde Ontbossingskans",
    "Very High Deforestation Probability": "Zeer Hoge Ontbossingskans",
    disputeReason: "Reden voor Geschil",
    disputeStatus: "Status van Geschil",
    farmRegId: "Boerderij Reg. Id",
    productionPlaceId: "Productieplaats ID",
    disputeId: "Geschil ID",
    disputeArea: "Oppervlakte van Geschil",
    disputeResolution: "Oplossing voor Geschil",
    selectDefaultMeasurementUnit: "Selecteer Standaard Meeteenheden",
    selectDefaultMeasurementUnitInfo:
      "Staat de selectie van de standaard meeteenheden toe, inclusief het specificeren van de eenheid, het instellen van een maximumlimiet en het markeren als de standaardoptie.",
    maxLimit: "Maximale Limiet",
    maxLimitInfo:
      "Stelt de hoogste toegestane waarde of drempel in voor een specifieke parameter.",
    asDefault: "Markeren als Standaard",
    productMass: "Product Massa",
    productMassUnitInfo:
      "Geeft de eenheid aan voor het meten van de massa van een product.",
    volumeUnitInfo:
      "Geeft de eenheid aan voor het meten van het volume van een product.",
    operatorInfo:
      "Verwijst naar een individu of entiteit die verantwoordelijk is voor het beheren of bedienen van een systeem of proces.",
    supplierInfo:
      "Een entiteit die goederen of diensten levert aan een andere entiteit.",
    userTypeInfo:
      "Classificeert individuen of entiteiten op basis van hun rol of machtigingen binnen het systeem.",
    unit: "Eenheid",
    userType: "Gebruikerstype",
    eudrPortalApiKeys: "EUDR Portaal API Sleutels",
    apiKey: "API Sleutel",
    apiSecret: "API Geheim",
    headingCreatedSuccessfully: "Succesvol aangemaakt",
    headingOrderSuccessfullyUpdated: "Bestelling succesvol bijgewerkt",
    orderSuccessfullyUpdated: "Bestelling is succesvol bijgewerkt",
    questionTypeNotDefined: "Vraagtype niet gedefinieerd",
    assessmentRiskMitigationLvl: "Risico Verminderingsniveaus Beoordeling",
    assessmentRiskMitigationLvlInfo:
      "Categoriseert de ernst van de risico's die verband houden met landgebruik, bosbouwpraktijken en landbouwexpansie. Deze niveaus helpen bij het identificeren van de potentiële impact van activiteiten op bosrijke gebieden en leiden de juiste acties om negatieve gevolgen te mitigeren. Categoriseert de niveaus van risicobeperkingsstrategieën, inclusief zeer hoog, hoog, gemiddeld, laag en nul/onbeduidend.",
    deforestationAssessmentRiskToleranceLevel:
      "Risicotolerantieniveau voor Ontbossingsbeoordeling",
    dynamicExpiryTime: "Dynamische Vervaltijd",
    dynamicExpiryTimeInfo:
      "Stelt een tijdsperiode in waarna bepaalde gegevens of instellingen automatisch vervallen. Configureert instellingen met betrekking tot rapporten over ontbossing, inclusief opties voor automatische verlenging.",
    eudrDeforestationAssessment: "EUDR Ontbossingsbeoordeling",
    autoRenewalIf:
      "Automatische Verlenging bij Toevoegen aan Due Diligence Rapport",
    declarationStatements: "Verklaring Verklaringen",
    declarationStatementsInfo:
      "Uitspraken gedaan door de verantwoordelijke partij die de nauwkeurigheid, volledigheid en authenticiteit van de informatie in het rapport certificeren.",
    filterDeclaration: "Filter Verklaring",
    declarationTitle: "Titel Verklaring",
    declarationTitleInfo:
      "Titel of koptekst voor een verklaring, die context biedt of de inhoud samenvat.",
    applicableCountry: "Toepasselijke Landen",
    applicableCountryInfo:
      "Lijst de landen waarop bepaalde instellingen of regelgeving van toepassing zijn.",
    addMore: "Meer Toevoegen",
    autoRenewal: "Automatische Vernieuwing",
    createNewAssessment: "Nieuwe Beoordeling Maken",
    userDimitraAssessment: "Gebruik Dimitra Beoordelingen",
    shipmentList: "Lijst van Zendingen",
    generalData: "Algemene Gegevens",
    check: "Controleren",
    zeroOrNeglegible: "Nul of Verwaarloosbaar",
    very_high: "Zeer Hoog",
    very_low: "Zeer Laag",
    tooltip: {
      dimitraFarmId:
        "Unieke identificatie gekoppeld aan een specifieke boerderij in het Dimitra-systeem.",
      farmName: "De toegewezen naam van de boerderij.",
      farmRegistrationId: "Registratienummer van de boerderij.",
      farmLocation:
        "Specifieke geografische coördinaten of locatie van de boerderij.",
      dimitraFermerId:
        "Een unieke identificatie gekoppeld aan een individuele boer binnen het Dimitra-systeem.",
      farmerName:
        "Identificatie van de persoon die verantwoordelijk is voor de boerderij.",
      farmerRegistrationId: "Registratienummer van de boer.",
      assessmentNo: "Uniek nummer toegewezen aan de beoordeling.",
    },
    red: "Rood",
    Yellow: "Geel",
    transparent: "Transparant",
    darkRed: "Donkerrood",
    brightRed: "Helderrood",
    orange: "Oranje",
    lightBlue: "Lichtblauw",
    teal: "Teal",
    zeroOrNegligibleProbability: "Nul/verwaarloosbare ontbossingskans",
    veryLowProbability: "Zeer lage ontbossingskans",
    lowProbability: "Lage ontbossingskans",
    mediumProbability: "Gemiddelde ontbossingskans",
    highProbability: "Hoge ontbossingskans",
    veryHighProbability: "Zeer hoge ontbossingskans",
    locationName: "Locatienaam",
    dueDeligence: "Uangalizi wa Bidhaa",
    supplierInformation: "Taarifa za Muuzaji",
    addNewSupplier: "Ongeza Muuzaji Mpya",
    name: "Jina",
    lastName: "Jina la Mwisho",
    email: "Barua pepe",
    phoneNumber: "Namba ya Simu",
    enterSupplierName: "Ingiza Jina la Muuzaji",
    enterSupplierLastName: "Ingiza Jina la Mwisho la Muuzaji",
    enterSupplierFirstName: "Ingiza Jina la Kwanza la Muuzaji",
    enterOperatorName: "Ingiza Jina la Mwendeshaji",
    enterEmailAddress: "Ingiza Anwani ya Barua Pepe",
    enterPhoneNumber: "Ingiza Namba ya Simu",
    whoWillAddPlace: "Nani Ataongeza Taarifa za Sehemu ya Uzalishaji?",
    companyId: "Kitambulisho cha Kampuni",
    activity: "Shughuli",
    placeOfActivity: "Mahali pa Shughuli",
    countryOfActivity: "Nchi ya Shughuli",
    operatorPlaceOfActivity: "Plaats van Activiteit van de Operator",
    operatorCountryOfActivity: "Land van Activiteit van de Operator",
    countryOfEntry: "Nchi ya Kuingia",
    productDetail: "Maelezo ya Bidhaa",
    subProduct: "Bidhaa Ndogo",
    productionDescription: "Maelezo ya Uzalishaji",
    netMass: "Misa Halisi",
    volume: "Kiasi",
    scietificName: "Jina la Kisayansi",
    commonName: "Jina la Kawaida",
    eudrDueDeligenceReports: "Ripoti za Uangalizi wa Bidhaa za EUDR",
    EUDRAssessmentReport: "Ripoti ya Tathmini ya EUDR",
    createNewReport: "Tengeneza Ripoti Mpya",
    eudrRefNo: "Namba ya Marejeo ya EUDR",
    eudrRefNoInfo:
      "Functionaliteit om specifieke informatie met betrekking tot de zending te vinden.",
    statusInfo:
      "De huidige status van de zending in relatie tot het due diligence-rapport.",
    eudrAndInternalRefNo: "Namba ya Marejeo ya EUDR / Ndani",
    exporterAndSupplier: "Exporteur & Muuzaji",
    internalRefNo: "Namba ya Marejeo ya Ndani",
    supplier: "Muuzaji",
    quantity: "Kiasi",
    product: "Bidhaa",
    noOfFarms: "Idadi ya Mashamba",
    farmsAndQuantity: "Boerderijen & Hoeveelheid",
    country: "Nchi",
    lastUpdated: "Ilisasishwa Mwisho",
    dueDeligenceStatus: "Hali ya Uangalizi wa Bidhaa",
    edurDueDeligenceStatus: "Hali ya Uangalizi wa Bidhaa ya EUDR",
    edurDueDeligenceReport: "Ripoti ya Uangalizi wa Bidhaa ya EUDR",
    reject: "Kataa",
    discard: "Tupa",
    saveAndContinueLater: "Hifadhi na uendelee baadaye",
    requestAdditionalInformation: "Omba taarifa za ziada",
    productionPlaces: "Sehemu za Uzalishaji",
    next: "Inayofuata",
    dueDeligenceReportCreation: "Uundaji wa Ripoti ya Uangalizi wa Bidhaa",
    producer: "Mzalishaji",
    select: "Chagua",
    productionPlacesFarmAndFarmId:
      "Mahali pa uzalishaji (Shamba) & Kitambulisho cha Shamba",
    producerName: "Jina la Mzalishaji",
    addressOfProduction: "Anwani ya Uzalishaji",
    type: "Aina",
    geofence: "Uzio wa Kidijitali",
    areaHa: "Eneo (ha)",
    editGeofence: "Hariri Uzio wa Kidijitali",
    totals: "Jumla",
    locationVerification: "Uthibitisho wa Eneo",
    AnalysisOfDeforestationStatus: "Uchambuzi wa Hali ya Ukataji Miti",
    EUDRDeforestationStatus: "Hali ya Ukataji Miti ya EUDR",
    removeAllLowRiskFarm: "Ondoa mashamba yote yenye hatari ndogo",
    removeAllHighRiskFarm: "Ondoa mashamba yote yenye hatari kubwa",
    attachRiskMigrationDoc:
      "Voeg één risicobeperkingsdocument toe voor alle boerderijen met een hoog risico",
    removedFarms: "Mashamba yaliyoondolewa kwenye orodha",
    generateCertificate: "Tengeneza Cheti",
    disputeAssessment: "Tathmini ya Mgogoro",
    requestAdditionalInformationShort: "Meer informatie aanvragen",
    uploadToEudr: "Uploaden naar EUDR",
    viewDisputeHistory: "Bekijk Geschiedenis van Geschillen",

    reportDetails: "Maelezo ya Ripoti",
    productionPlace: "Mahali pa Uzalishaji",
    regionalRiskAssessment: "Regionale Risicobeoordeling",
    EUDRDeforestationAssessment: "Tathmini ya Ukataji Miti ya EUDR",
    EUDRcountry:
      "Het land waar de boerderij zich bevindt, gekoppeld aan het product in het due diligence-rapport. Het helpt bij het waarborgen van geografische traceerbaarheid zoals vereist door EUDR-regelgeving.",
    riskAssessment: "Tathmini ya Hatari",
    legalInformation: "Taarifa za Kisheria",
    finalReport: "Ripoti ya Mwisho",
    editGeolocation: "Hariri Eneo la Kijiografia",
    producerCountry: "Nchi ya Mzalishaji",
    manuallyAddData: "Ongeza Data Kwa Mkono",
    drawGeofence: "Chora Uzio wa Kidijitali",
    uploadFile: "Pakia Faili",
    typeyourlocation: "Andika jina/anwani ya eneo lako",
    numberOfPoints: "Idadi ya Pointi za Poligoni",
    viewGeolocation: "Tazama Eneo la Kijiografia",
    geoLocation: "Eneo la Kijiografia",
    Point: "Nukta",
    Circular: "Cirkelvormig",
    Polygon: "Poligoni",
    selectFileToUploadData: "Chagua faili la kupakia data",
    submissionDate: "Datum van Indiening",
    eudrReferenceNo: "EUDR Referentienummer",
    internalReferenceNo: "Intern Referentienummer",
    exporter: "Exporteur",
    exporterInfo:
      "Naam van de exporteur. De entiteit of partij die verantwoordelijk is voor het exporteren van de goederen.",
    importer: "Importeur",
    importerInfo:
      "Naam van de importeur. De entiteit of partij die verantwoordelijk is voor het importeren van de goederen.",
    shipmentReferenceNo: "Verzendingsreferentienummer",
    shipmentReferenceNoInfo:
      "Een unieke identificatie gebruikt om de zending te refereren.",
    ownerShipType: "Eigendom Type",
    ownerShipTypeInfo: "Het type eigendom dat met de zending is geassocieerd.",
    buyer: "Koper",
    port_of_origin: "Haven van Oorsprong",
    port_of_origin_info: "De locatie waar de zending vandaan komt.",
    port_of_destination: "Haven van Bestemming",
    port_of_destination_info: "De beoogde bestemminghaven voor de zending.",
    no_of_stops: "Aantal Stops",
    shipping_line: "Vrachtlijn",
    shipping_line_info:
      "Het bedrijf of de entiteit die verantwoordelijk is voor het transporteren van de zending.",
    expected_arrival_date: "Verwachte Aankomstdatum",
    expected_arrival_date_info:
      "Verwachte aankomstdatum voor de zending op de bestemming.",
    container_id: "Container-ID",
    container_id_info:
      "Identificador único para el contenedor de envío utilizado en el envío.",
    container_type: "Containertype",
    container_type_info: "Het type of de categorie van verzendcontainer.",
    container_size: "Containergrootte (ft)",
    container_size_info: "De fysieke afmetingen van de verzendcontainer.",
    container_capacity: "Containercapaciteit (Ton)",
    container_capacity_info:
      "De maximale lading of capaciteit van de verzendcontainer.",
    eudr_reference_number: "EUDR Referentienummer",

    select_default_measurement_units: "Selecteer Standaard Meet Eenheden",
    radius: "Straal",
    maximum_limit: "Maximale Limiet",
    product_mass: "Product Massa",
    user_type: "Gebruikerstype",
    eudr_api_keys: "EUDR Portaal API Sleutels",
    api_key: "API Sleutel",
    api_secret: "API Geheim",
    assessment_risk_mitigation_levels:
      "Niveaus van Risicobeperking bij Beoordeling",
    dynamic_expiry_time_period: "Dynamische Verlooptijd",
    eudr_deforestation_assessment: "EUDR Ontbossingsbeoordeling",
    auto_renewal: "Automatische Vernieuwing",
    auto_renewal_when_added_to_the_due_diligence_report:
      "Automatische Vernieuwing Wanneer Toegevoegd aan Due Diligence Rapport",
    declaration_statements: "Verklaringen",
    filter_declaration_statements: "Filter Verklaringen",
    showing_all: "Alles Tonen",
    declaration_title: "Titel van Verklaring",
    applicable_countries: "Toepasselijke Landen",
    enabled: "Ingeschakeld",
    disabled: "Uitgeschakeld",
    add_more: "Meer Toevoegen",
    mark_as_default: "Markeren als Standaard",
    locationVerificationTab: {
      confirmationTitle: "Bevestiging",
      confirmationMessage:
        "Je staat op het punt de geolocatiegegevens van deze boerderij te bewerken. Houd er rekening mee dat elke wijziging in de geolocatie een herverificatie vereist van alle gerelateerde stappen, inclusief locatieverificatie, ontbossingsanalyse en regionale risicobeoordeling (controles op beschermde en inheemse gebieden). Wijzigingen in de naam van de boerderij of boer vereisen geen herverificatie. Wil je doorgaan?",
    },
    locationModified: {
      headerTitle: "Locaties Gewijzigd",
      headerDescription:
        "We hebben gedetecteerd dat de volgende locatie(s) zijn gewijzigd en opnieuw moeten worden geverifieerd.",
    },
    processingDialog: {
      modalHeader: "Ontbossingsstatus Analyseren",
      modalDescription_first: "Analyseren van de EUDR Ontbossingsstatus",
      modalDescription_second:
        "Je boerderijen ondergaan een Geautomatiseerde Ontbossingsanalyse. Je wordt doorgestuurd naar de pagina met de lijst van Due Diligence-rapporten om de status te bekijken.",
    },
    farmList: {
      title: "EUDR Boerderijlijst",
      addFarmGeofenceManually: "Boerderij-geofence handmatig toevoegen",
      importGeofenceInBulk: "GEO-CENCEN BULK IMPORTEREN",
      searchPlaceHolder: "Zoeken op naam van boer",
      generateCertificate: "Certificaat genereren",
      requestAssementReport: "Beoordelingsrapport aanvragen",
      producer: "Producent",
      farmNameAndId: "Boerderijnaam en ID",
      addressOfProduction: "Productieadres",
      registrationDate: "Registratiedatum",
      eudrDeforestationStatus: "EUDR Ontbossingsstatus",
      riskAssessmentStatus: "Risico-beoordelingsstatus",
      assessmentTitle: "Beoordelingstitel",
      assessmentDescription: "Beoordelingsbeschrijving",
      submissionDate: "Datum van indiening",
      expiryDate: "Vervaldatum",
      assessmentStatus: "Beoordelingsstatus",
      downloadAsKmx: "Downloaden als KMX",
      downloadAsKml: "Downloaden als KML",
      downloadAsShp: "Downloaden als SHP",
      downloadAsCsv: "Downloaden als CSV",
      downloadAsExcel: "Downloaden als EXCEL",
      downloadAsPdf: "Downloaden als PDF",
      downloadAsGeoJson: "Downloaden als GeoJSON",
      loadingFarms: "Boerderijen laden",
    },

    dueDeligenceReport: "Configuratie van het Due Diligence Rapport",
    allowPublicDownload:
      "Sta openbare download van boerderijhekken in GeoJson-formaat toe",
    showDeforestationSummary:
      "Toon samenvatting van het EUDR ontbossingsrisico per categorie",
    actions: "Actie",
    cancel: "Annuleren",
    createShipment: "Zending Aanmaken",
    buyerName: "Naam van de koper",
    operator: "Mtendaji",
    download: "Download",
    print: "Print",
    loading: "Laden...",
    tons: "Ton",

    failedToDeleteQuestion: "Vraag verwijderen mislukt",
    questionOrderSuccessfullyUpdated:
      "Volgorde van vragen succesvol bijgewerkt",
    assessmentUpdatedSuccessfully: "Beoordeling succesvol bijgewerkt",
    pleaseWaitCurrentlyUpdatingChecklist:
      "Even geduld, de checklist wordt bijgewerkt",
    riskMitigation: "Risicobeperking",
    riskMitigarionHistory: "Geschiedenis van Risicobeperking",
    signParticipationSurvey:
      "Vorresti gentilmente firmare digitalmente per confermare la tua partecipazione a questo sondaggio?",
    signedBy: "Digitaal ondertekend door:",
    assessmentRiskMitigation: "Beoordeling Risicobeperking",
    assessmentDetails: "Beoordelingsdetails",
    dontShowWarning: "Laat deze waarschuwing niet meer zien.",
    dateSubmitted: "Datum ingediend",
    addAComment: "Voeg een opmerking toe",
    changeAssignee: "Wijzig toegewezene",
    changeStatus: "Wijzig status",
    assignedUser: "Toegewezen gebruiker",
    selectAssignee: "Selecteer toegewezene",
    reply: "Antwoorden",
    discussion: "Discussie",
    attachment: "Bijlage",
    sizeKb: "Grootte (KB)",
    dateAdded: "Datum toegevoegd",
    shipmentStatus: "Verzendstatus",
    viewStops: "Bekijk Stops",
    enRoute: "Onderweg",
    delivered: "Geleverd",
    failed: "Mislukt",
    removeEudrDeforestationStatus: "Verwijder EUDR Ontbossingsstatus",
    riskAssessmentStatusIsRequired: "Risicobeoordelingsstatus is vereist",
    requestAdditionalInformationPage: {
      descriptionLabel: "Geef specifieke opmerkingen of instructies in het onderstaande tekstvak. Na verzending wordt de leverancier op de hoogte gebracht en krijgt toegang om het due diligence-rapport te bewerken. U wordt op de hoogte gesteld wanneer de leverancier het rapport bijwerkt.",
      shareAccessLabel: "De leverancier heeft momenteel geen toegang tot dit rapport. Wilt u toegang delen met de leverancier? Kies hoe u toegang wilt delen:",
      shareCompleteReportLabel: "Volledig rapport delen",
      shareSpecificStepLabel: "Specifieke stap delen"
    },
    issueFound: "Probleem gevonden",
    complianceRiskWarningsTT: "Risicowaarschuwingsmeldingen wijzen u op mogelijke nalevingsproblemen bij elke stap van het due diligence-proces. Deze meldingen helpen ervoor te zorgen dat alle risico's worden geïdentificeerd voordat u doorgaat naar de volgende fase. U kunt deze waarschuwingen op elk moment in de rapportinstellingen of tijdens het aanmaken van het rapport in- of uitschakelen.",
    statusLegend: "Statuslegenda",
    statusLegendInfo: "De statuslegenda geeft een snel overzicht van de huidige status van het due diligence-rapport. Het wordt gebruikt om de huidige status van het rapport aan te geven en de acties die kunnen worden ondernomen om het rapport bij te werken.",
    sentToExporter: "Verzonden naar Exporteur",
    approved: "Goedgekeurd",
    updateRequired: "Bijwerking Vereist",
    rejected: "Afgewezen",
    noExporterFound: "Geen exporteur gevonden",
    exporterFoundSuccessfully: "Exporteur succesvol gevonden",
    enterExporterEmail: "Voer exporteur-e-mailadres in",
    shareReport: "Rapport delen",
    exporterInformation: "Exporteur Informatie",
    pleaseEnterExporterEmail: "Voer alstublieft het e-mailadres van de exporteur in",

    // Activity Log translations
    activityLog: "Activiteitenlog",
    activityLogTT: "Logboek van acties die op dit rapport zijn uitgevoerd.",
    user: "Gebruiker",
    userRole: "Gebruikersrol",
    ipAddress: "IP-adres",
    segment: "Segment",
    activityDescription: "Omschrijving van de activiteit",

  },
  dueDiligence: {
    comments: "Opmerkingen",
    commentsRegardingStatement: "opmerkingen met betrekking tot verklaring",
    countryOfProduction: "Land van Productie",
    countryOfProductionTT: "Land van Productie",
    containerId:"Container-id",
    createWithoutRiskAssessment: {
      title: "Maak DDS zonder risicobeoordeling",
      message: "Wilt u een DDS maken zonder een risicobeoordeling toe te voegen? In dat geval worden de regels voor klachtcontrole overgeslagen.",
      confirmBtnText: "Ja",
      cancelBtnText: "Nee"
    },
    noAssessmentWarning: "Het DDS-rapport mist risicobeoordelingen.",
    disputeReason: "Kies een reden voor het geschil.",
    agricultureAgreement:
      "Ga akkoord met de voorwaarden voordat u verder gaat.",
    attachDisputeFile: "Voeg een bestand toe voordat u een geschil aanmeldt.",
    listOfFarmsInfo:
      "Een uitgebreide weergave van boerderijen, inclusief informatie zoals de productielocatie, de naam van de producent, het land waar de boerderij actief is, het landoppervlak in hectare, het soort landbouwactiviteiten, beoordelingen met betrekking tot ontbossing en evaluaties van potentiële risico's die verband houden met de boerderijactiviteiten.",
    producerTT:
      "Selectie van producenten of fabrikanten die betrokken zijn in de toeleveringsketen.",
    supplierInformationTT:
      "Details over de entiteit die goederen of diensten levert.",
    operatorTooltip:
      "Selecteer de operator uit de vooraf geregistreerde lijst in het systeem",
    operatorSelect:
      "Operator: Kies deze optie als u, als operator, verantwoordelijk bent voor het toevoegen van productielocatiegegevens. U heeft de mogelijkheid om een lijst van producenten, hun boerderijen en de geolocaties in de app te verstrekken.",
    supplierSelect:
      "Leverancier: Kies deze optie als de leverancier verantwoordelijk is voor het toevoegen van productielocatiegegevens. Zij hebben toegang om de lijst met producenten, hun boerderijen en de geolocaties direct in de app in te voeren.",
    selectWhoWillAddPlaceData:
      "Selecteer wie de productielocatiegegevens zal toevoegen",
    supplierTooltip:
      "Selecteer de leverancier uit de vooringeschreven lijst in het systeem.",
    requiredAssessmentTooltip: "Kies de benodigde beoordelingsinformatie.",
    internalRefNoTooltip:
      "Een unieke identificatie die binnen een organisatie of systeem wordt toegekend om te verwijzen naar specifieke gegevens, transacties of registraties voor interne tracering en beheer.",
    eudrRefNoTooltip:
      "Verwijst naar een unieke identificatie die is gekoppeld aan de Europese Ontbossingsverordening (EUDR), meestal gebruikt om informatie met betrekking tot naleving van ontbossingsvoorschriften te volgen en te refereren.",
    companyIdTooltip:
      "Een onderscheidende identificatie toegewezen aan een bedrijf of organisatie voor identificatie en tracering, vaak gebruikt in systemen, databases of regelgeving.",
    placeOfActivityTooltip:
      "Verwijst naar de specifieke activiteit of operatie die wordt uitgevoerd in het due diligence-rapport. Geeft de locatie of landen aan die betrokken zijn bij de activiteit, inclusief het land van activiteit en het land van binnenkomst.",
    productDetailToolTip:
      "Biedt gedetailleerde informatie over het product, inclusief de naam, netto massa, volume, wetenschappelijke naam en algemene naam.",
    productToolTip:
      "Productnaam. Verwijst naar een tastbaar item of goed dat wordt geproduceerd, vervaardigd of verhandeld door een bedrijf.",
    productDescToolTip:
      "Geeft een tekstuele uitleg of samenvatting van de kenmerken, functies of attributen van een product, met als doel gebruikers of klanten te informeren over de aard of functionaliteit.",
    subProductToolTip:
      "Naam van het subproduct. Duidt op een specifieke categorie of subcategorie binnen een bredere productcategorie, meestal gebruikt voor aanvullende classificatie of differentiatie binnen een producthiërarchie.",
    netMassTooltTip:
      "Geeft het gewicht van een product of item aan, meestal exclusief het gewicht van de verpakking of andere materialen.",
    volumeToolTip:
      "Verwijst naar de hoeveelheid ruimte die door een product of stof wordt ingenomen, meestal gemeten in kubieke eenheden zoals kubieke meters of kubieke voeten, gebruikt om de capaciteit of hoeveelheid in de driedimensionale ruimte te kwantificeren.",
    scientificNameToolTip:
      "Taxonomische naam van een organisme bestaande uit geslacht en soort, bijvoorbeeld Coffea Arabica, Theobroma cacao L.",
    commonNameToolTip:
      "Een naam gebaseerd op dagelijks taalgebruik, bijvoorbeeld Cacao, Koffie.",
    manualProductionPlaceTooltip:
      "Proces van handmatige invoer van productielocaties in het systeem.",
    producerNameTT:
      "De naam van een individu/bedrijf/organisatie die goederen of diensten creëert en levert.",
    producerCountryTT: "Het land van herkomst van de producent.",
    dueDiligence: "Uangalizi wa Bidhaa EUDR",
    assementBuilder: "Mtengeneza Tathmini",
    assessment: "Tathmini",
    assessmentsList: "Orodha ya Tathmini",
    createAssessment: "Tengeneza Tathmini",
    assessmentName: "Jina la Tathmini",
    assessmentNameInfo:
      "Functionaliteit om specifieke beoordelingen of informatie te vinden.",
    searchAssessment: "Tafuta Tathmini",
    selectProcess: "Chagua Mchakato wa Tathmini",
    assessSettings: "Mipangilio ya Tathmini",
    assessmentTitle: "Kichwa cha Tathmini",
    assessmentTitleInfo: "Naam die een beoordeling identificeert.",
    assessDescription: "Maelezo ya Tathmini",
    assessDescriptionInfo:
      "Korte uitleg van het doel of de inhoud van de beoordeling.",
    describeAsessment: "Eleza Tathmini",
    selectCountry: "Chagua Nchi",
    expiryTime: "Wakati wa Kumalizika",
    expiryTimeInfo: "Duur totdat de beoordeling verloopt of ongeldig wordt.",
    noQuestionEachStep: "Idadi ya Maswali",
    byHeadings: "Kwa Vichwa",
    assessmentStatus: "Hali ya Tathmini",
    multiStepAssess: "Tathmini ya Hatua Nyingi",
    allowAssessment: "Ruhusu tathmini kujibiwa mara nyingi",
    onlyIfExpired: "Tu ikiwa Imekwisha",
    atAnyTime: "Wakati Wowote",
    editAssessmentDetails: "Hariri Swali la Tathmini",
    assessmentDetail: "Maelezo ya Tathmini",
    addQuestion: "Ongeza Swali la Tathmini",
    attachFiles: "Ambatisha Faili",
    digitalSignature: "Saini ya Kidijitali",
    showChecklist: "Onyesha Orodha ya Ukaguzi",
    hideChecklist: "Ficha Orodha ya Ukaguzi",
    fileType: "Aina ya Faili",
    allowMultipleFile: "Ruhusu Viambatisho Vingi",
    allowComment: "Ruhusu Maoni",
    uploadSignatureFile: "Pakia Faili la Saini",
    drawSignature: "Chora Saini",
    addSubHeading: "Ongeza Kichwa cha Chini",
    heading: "Kichwa",
    headingInfo:
      "Kop waaronder de beoordelingsvraag wordt gecategoriseerd. Een keuzemenu om de kop te selecteren.",
    subHeading: "Kichwa kidogo",
    logistics: "Logistiek",
    editSubHeading: "Subkop Bewerken",
    headingTitle: "Titel Hoofding",
    partOfOrigin: "Oorsprongsdeel",
    destination: "Bestemming",
    addStop: "Stop Toevoegen",
    stop: "Stop",
    enterStop: "Voer Stop In",
    shipmentList: "Lijst van Zendingen",
    createShipment: "Nieuwe Zending Maken",

    dueDiligenceReports: "Ripoti za Uangalizi wa Bidhaa",
    manageFarms: "Simamia Mashamba",
    disputeResolution: "Utatuzi wa Migogoro",
    suppliers: "Wasambazaji",
    shipments: "Mizigo",
    dueDiligenceGuide: "Mwongozo wa Uangalizi wa Bidhaa",

    selectRequiredAssessment: "Chagua Tathmini Zinazohitajika",
    filterAssessments: "Chuja Tathmini",
    dueDiligenceReportCreation: "Uundaji wa Ripoti ya Uangalizi wa Bidhaa",

    dueDiligenceNew: "Uangalizi wa Bidhaa",
    createNewReport: "Tengeneza Ripoti Mpya",
    operator: "Mtendaji",
    supplier: "Muuzaji",
    addMoreAssessments: "Ongeza Tathmini Zaidi",
    internalReferenceNumber: "Nambari ya Rejea ya Ndani",
    referenceNumber: "Nambari ya Rejea",
    domestic: "Ndani ya Nchi",
    import: "Ingiza",
    export: "Hamisha",
    selectProduct: "Chagua Bidhaa",
    selectSubProduct: "Chagua Bidhaa Ndogo",
    addnewSupplier: "Ongeza Muuzaji Mpya",
    farmDeforestationReport: "Ripoti ya Ukataji Miti ya Shamba",

    addProductionPlaceData: "Productieplaatsgegevens Toevoegen",
    addProductionPlaceDataTooltip: "Kies hoe je gegevens wilt toevoegen",
    addProductionPlaceDataDesc:
      "Maak je rapporten door productiegegevens te integreren uit verschillende bronnen. Selecteer één of meerdere bronnen om een uitgebreide lijst van productieplaatsen samen te stellen voor je rapporten.",
    dimitraApps: "Dimitra Apps",
    addNew: "Nieuw Toevoegen",
    existingData: "Bestaande Gegevens",
    manualDataEntry: "Handmatige Gegevensinvoer",
    importFile: "Bestand Importeren",
    connectedCoffee: "Gekoppelde Koffie",
    connectedCacao: "Gekoppelde Cacao",
    connectedFarmer: "Verbonden Boerderij",
    manaulProductionPlace: "Handmatige Productieplaats Gegevensinvoer",
    manaulProductionPlaceTooltip:
      "Proces van handmatige invoer van productielocaties in het systeem.",
    addProductionPlace: "Productieplaats Toevoegen",
    producerName: "Producentnaam",
    producerCountry: "Producentland",
    totalArea: "Totale Oppervlakte",
    number: "Nummer",
    productionPlaceDesc: "Beschrijving van Productieplaats",
    area: "Oppervlakte  (ha)",
    type: "Type",
    actions: "Acties",
    selectType: "Selecteer Type",
    importProductionPlace: "Productieplaats Importeren",
    downloadCSVFormat: "Download XLS Formaat",
    downloadXLSFormat: "Download XLS Formaat",
    downloadGeoJsonFormat: "Download GeoJSON Formaat",
    downloadXMLFormat: "Download XML Formaat",
    downloadFileFormatTemplates: "Download Bestandsformaat Sjablonen",
    importantNote: "Belangrijke Opmerking",
    pleaseProvideFollowing:
      "Gelieve de volgende formaten te verstrekken (GeoJSON en XML)",
    existingProductionPlaces: "Bestaande Productieplaatsen",
    productionPlaceAndFarmID: "Productieplaats & Boerderij ID",
    selectFileToUploadData: "Selecteer bestand om de gegevens te uploaden",
    filterByDate: "Filteren op datum",
    dateOfRegister: "Registratiedatum",
    dateOfLastReport: "Datum van het laatste rapport",
    clearAll: "Alles wissen",
    addLocation: "Locatie toevoegen",

    pleaseCompleteBeforeProceedingToNext:
      "Voltooi de rapportagedetails voordat u doorgaat naar de volgende stap.",
    progressSavedSuccessMsg: "Voortgang succesvol opgeslagen!",
    failedSavedProgress: "Opslaan van voortgang mislukt. Probeer het opnieuw.",
    failedToCreateReportDetails:
      "Het aanmaken van ReportDetails is mislukt. Probeer het opnieuw.",
    unExpectedErrorMsg:
      "Er is een onverwachte fout opgetreden. Probeer het opnieuw.",
    selectAssessment: "Selecteer Beoordeling",
    confirmationPopup: "Bevestigingsvenster",
    confirmationPopupMsg:
      "Weet u zeker dat u dit rapport wilt verwijderen? Het bevestigen van deze actie leidt tot permanente verwijdering.",
    confirmation: "Bevestiging",
    saveAndConfirmationMessage:
      "Weet je zeker dat je de wijzigingen wilt opslaan?",
    confirmDownload:
      "Wil je alle bijgevoegde bestanden in PDF-formaat downloaden?",
    supplierNotRegisterContent:
      "De leverancier is niet geregistreerd. Wil je een melding naar de leverancier sturen om zich via e-mail aan te melden voor het platform?",
    warningPopup: "Waarschuwingsvenster",
    warningPopupMsg:
      "Weet u zeker dat u dit rapport wilt afwijzen? Let op: De gegevens van dit rapport worden na afwijzing opgeslagen voor latere herziening.",
    automatedDeforestationProgressText:
      "Geautomatiseerde ontbossingscontrole van geovalladata en identificatie van kritieke gevallen",
    someRiskWereIdentifiedText:
      "Er zijn enkele risico's geïdentificeerd op de volgende boerderij, u moet de boerderij met de geïdentificeerde risico's bekijken en deze mitigeren voordat u doorgaat naar de volgende stap.",
    riskAssessmentAndMitigation: "Risicobeoordeling en -mitigatie",
    riskAssessmentStatus: "Status van Risicobeoordeling",
    riskAssessment: "Risicobeoordeling",
    uploadRiskAssessment: "Upload Risicobeoordeling",
    uploadRiskAssessmentTT:
      "Actie om een risicobeoordelingsdocument te uploaden.",
    manualFillOutAssessment: "Vul beoordeling handmatig in",
    manualFillOutAssessmentTT:
      "Actie om een beoordelingsformulier handmatig in te vullen.",
    criteria: "Criteria (b, f en g)",
    downloadAssessmentForm: "Download Beoordelingsformulier",
    addSignature: "Handtekening Toevoegen",
    uploadImage: "Afbeelding Uploaden",
    createNewDueDiligenceProgress: "Nieuw Due Diligence Proces Maken",
    usageLimits: "Gebruiksbeperkingen",
    totalReports: "Totaal Aantal Rapporten",
    eudrDeforestationAssessments: "EUDR Ontbossing Beoordelingen",
    totalAssessments: "Totaal Aantal Beoordelingen",
    listOfFarms: "Lijst van Boerderijen",
    perMonth: "Per Maand",
    share: "Delen",
    viewReport: "Rapport Bekijken",
    viewReportSummary: "Bekijk samenvatting van het rapport",
    copy: "Kopiëren",
    copyAndCreateNew: "Kopiëren en Nieuw Maken",
    listOfSupplier: "Lijst van Leveranciers",
    addNewSupplier: "Nieuwe leveranciers toevoegen",
    editSupplier: "Leverancier Bewerken",
    supplierName: "Naam van Leverancier",
    listOfOperators: "Lijst van Exploitanten",
    addNewOperator: "Nieuwe Exploitanten Toevoegen",
    operatorName: "Naam van Exploitant",
    operators: "Exploitanten",
    editOperator: "Exploitant Bewerken",
    eoriNumber: "EORI Nummer",
    enterEmailAddress: "Voer e-mailadres in",
    enterFirstName: "Voer voornaam in",
    enterLastName: "Voer achternaam in",
    enterEORINumber: "Voer EORI-nummer in",
    myFarms: "Mijn Boerderijen",
    listOfProducers: "Lijst van Producenten",
    producers: "Producenten",
    addNewProducer: "Nieuwe Producent Toevoegen",
    lastAssessment: "Laatste Beoordeling",
    noOfFarms: "Aantal Boerderijen",
    shipmentID: "Verzending ID",
    noOfReports: "Aantal Rapporten",

    selectProductionPlacesUsingLots:
      "Selecteer productielocaties met gebruik van kavels",
    SelectProductionPlacesUsingFarms:
      "Selecteer productielocaties met gebruik van boerderijen",

    areaForPointGeofence: "Gebied voor Circulaire Geofence",
    accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon:
      "Volgens EUDR hebben boerderijen kleiner dan 4 hectare geen polygon nodig.",
    circularAreaEquivalent:
      "In deze gevallen zullen we een cirkelvormig gebied gebruiken dat gelijkwaardig is aan de grootte van de boerderij, met het verstrekte GPS-punt als middelpunt om ontbossing te controleren. Wanneer de grootte van de boerderij niet wordt verstrekt, gebruiken we standaard 4 hectare.",
    ifTheFarmsAreSmallerPleaseEnterTheStandardSizeInTheFieldBelow:
      "Als de boerderijen kleiner zijn, voer dan de standaardgrootte in het onderstaande veld in.",
    defaultCircularGeofence:
      "Boerderijen zonder geofence of zonder informatie over hun grootte krijgen een standaard cirkelvormige geofence van 4 hectare toegewezen. Als de gemiddelde grootte van de boerderij minder dan 4 hectare is, wijzig dan de standaardgrootte door op de knop 'Bewerken' hieronder te klikken.",
    defaultAreaValueSpecified:
      "Boerderijen zonder geofence of gebied krijgen de hieronder gespecificeerde standaardgebiedswaarde en krijgen een circulaire geofence met een cirkelvormige straal toegewezen.",
    uploadFileBeingProcessed:
      "Je geüploade bestanden worden verwerkt. Je wordt doorverwezen naar de lijstpagina van zorgvuldigheidsrapporten om de status te bekijken.",
    processingLocations: "Locaties verwerken",

    lotId: "Kavel-ID",
    product: "Product",
    qualityGade: "Kwaliteitsgraad",

    importProductionPlaceTT:
      "Hiermee kunnen gebruikers productielocatiegegevens importeren met behulp van upload- of downloadopties.",
    internalReferenceNumberTT:
      "Een intern referentienummer of code gebruikt om zorgvuldigheidsrapporten te organiseren en te beheren.",

    onlyShowFarmsWithIssues: "Toon alleen boerderijen met problemen",

    analyzingStatus: "Analyseren van Ontbossingsstatus",
    analyzingDesc:
      "Je boerderijen ondergaan een geautomatiseerde ontbossingsanalyse. Je wordt doorgestuurd naar de pagina met due diligence-rapporten om de status te bekijken.",
    readyToProceed: "Klaar om Door te Gaan",
    mitigationRequired: "Mitigatie Vereist",
    viewSummary: "Bekijk Samenvatting",
    viewAssessment: "Bekijk Beoordeling",
    disputes: "Geschillen",
    manualRiskMitigation: "Handmatige Risico-mitigatie",
    veryHighProbability: "Zeer Hoge Kans",
    highProbability: "Hoge Kans",
    mediumProbability: "Middelmatige Kans",
    lowProbability: "Lage Kans",
    veryLowProbability: "Zeer Lage Kans",
    zeroProbability: "Nul/Nauwelijks Kans",
    manualMitigated: "Handmatig Gemitigeerd",
    disputeDesc:
      "Klik op een van de onderstaande geschillen om meer details te bekijken.",
    geofenceColorCode: "Geofence Kleurcode:",
    noDisputeHaveSubmitted: "Er is nog geen geschil ingediend",
    disputeDetails: "Geschil Details",
    chooseDisputeReason: "Kies Geschil Reden",
    pleaseAttachDoc:
      "Voeg documenten/foto's toe om je antwoord te ondersteunen.",
    additionalNotes: "Aanvullende Opmerkingen",
    aggrementStatement:
      "Ik begrijp dat het getroffen land de komende jaren niet voor landbouw zal worden gebruikt.",
    addGeofenceRadius: "Voeg Geofence Straal Toe",
    totalGeofenceRadius: "Totale Geofence Straal is",
    resolutionHistory: "Oplossingsgeschiedenis",
    proceed: "Doorgaan",
    wildFire: "Wilde Brand",
    controlledFire: "Gecontroleerde Brand",
    clearingForAgriculture: "Land Clearing voor Landbouw en/of Veeteelt",
    pestAndDiseases: "Plagen en Ziekten",
    naturalChangesInCanopy:
      "Natuurlijke Veranderingen in het Loof (zoals seizoensgebonden bladval)",
    strongWinds: "Sterke Winden (zoals orkanen of tornado's)",
    otherNaturalDisasters: "Andere Natuurlijke Rampen",
    flooding: "Overstromingen",
    logging: "Houtkap",
    infrastructure: "Infrastructuur",
    urbanization: "Urbanisatie",
    landGrabbingOrPopulationPressure:
      "Grondroof, Subsistentielandbouw of Bevolkingsdruk",
    mining: "Mijnbouw",
    plantationForestBeforeDeadline:
      "Het is een plantagebos of bebost land, maar primaire bossen of natuurlijk herstellende bossen zijn omgezet in plantagebossen of ander bebost land vóór de deadline (31 december 2020)",
    convertedToPlantationForest:
      "Primaire bossen of natuurlijk herstellende bossen zijn omgezet in plantagebossen of ander bebost land",
    cultivatedAreaBeforeDeadline:
      "Het is een gecultiveerd gebied en is na de deadline (31 december 2020) niet ontbost",
    forestStillPreserved:
      "Er is nog steeds een bos in het gebied, maar het is niet ontbost en is nog steeds bewaard",
    downloadAsPDF: "Download als PDF",
    downloadAsJSON: "Downloaden als JSON",
    downloadOptions: "Downloadopties",
    productionPlacesHighDeforestationProbability:
      "Productieplaatsen hebben een hoge kans op ontbossing",
    geofenceHighDeforestationProbability:
      "Geofence heeft een hoge kans op ontbossing",
    EUDRReferenceNumber: "EUDR Referentienummer",
    commonName: "Algemene Naam",
    totalNoOfRiskAssessment: "Totaal Aantal Risicobeoordelingen",
    totalNoOfHighDeforestation:
      "Totaal Aantal Boerderijen met Hoge Ontbossingskans",
    totalNoOFDeforestationAssessments: "Totaal Aantal Ontbossingsbeoordelingen",
    totalNoOfFarms: "Totaal Aantal Boerderijen",
    totalNoOfGeofencePoints: "Totaal Aantal Geofencepunten",
    totalNoOfGeofencePolygons: "Totaal Aantal Geofencepolygons",
    reportSummary: "Rapport Samenvatting",
    supplierData: "Leverancier Gegevens",
    isoCode: "ISO Code",
    operatorData: "Operator Gegevens",
    dueDiligenceReportStatus: "Status van Due Diligence Rapport",
    declarationStatement: "Verklaring van de Operator",
    undoDelete: "Verwijder Ongedaan Maken",
    analyzingDeforestation: "Analyseren van Ontbossing",
    processingFarm: "Boerderij Verwerken",
    processingGeofence: "Geofence Verwerken",

    supplierTT:
      "Selectie van leveranciers of fabrikanten betrokken bij de toeleveringsketen.",
    pleaseSelectAtLeastOneItem: "Selecteer alstublieft minstens één item.",

    uploadingToBlockchain:
      "Rapport naar blockchain uploaden, even geduld aub...",
    beingUploadToBlockChain:
      "Uw Due Diligence-rapport wordt naar de blockchain geüpload. U wordt doorgestuurd naar de lijst met Due Diligence-rapporten om de status te bekijken.",
    uploading: "Uploaden",
    attachFile: "Bestand Bijvoegen",
    close: "Sluiten",
    status: "Status",
    lotID: "Lot ID",
    noOfFarm: "Aantal Boerderijen",
    processingDate: "Verwerkingsdatum",
    origin: "Oorsprong",
    selectUsingLots: "Selecteer Productielocaties met Hulp van Loten",
    productionPlaceUsingFarms:
      "Selecteer Productielocaties met Hulp van Boerderijen",
    searchFarmName: "Zoek boerderijnaam",
    viewLocation: "Bekijk Geolocatie",
    netMassKG: "Nettomassa (kg)",
    volumeM3: "Volume (m³)",
    areaInHA: "Oppervlakte (ha)",
    eudrUploadedToBlockChain:
      "Succes! Het EUDR Due Diligence-rapport is succesvol geüpload naar de Blockchain.",
    viewDeforestationAssessment: "Bekijk Ontbossingsbeoordeling",
    viewDeforestationCertificate: "Bekijk Ontbossingscertificaat",
    selectCountries: "Selecteer Landen",
    writingToBlockchain: "Schrijven naar Blockchain",

    cattle: "Vee",
    cocoa: "Cacao",
    coffee: "Koffie",
    wood: "Hout",
    soya: "Soja",
    rubber: "Rubber",
    oilPlam: "Palmolie",

    subProduct1: "0102 21 , 0102 29 Levend vee",
    subProduct2: "0201 Rundvlees, vers of gekoeld",
    subProduct3: "0202 Rundvlees, bevroren",
    subProduct4: "0206 10 Eetbare slachtafvallen van runderen, vers of gekoeld",
    subProduct5: "0206 22 Eetbare runderlevers, bevroren",
    subProduct6:
      "0206 29 Eetbare slachtafvallen van runderen (exclusief tongen en levers), bevroren",
    subProduct7:
      "1602 50 Ander bereidingen en conserven van vlees, slachtafvallen en bloed van runderen",
    subProduct8:
      "4101 Ruwe huiden en vellen van runderen (vers, gezouten, gedroogd, gekalkt, gepekeld of op andere wijze geconserveerd, doch niet gelooid, niet tot perkament verwerkt of verder bewerkt), ook indien onthaard of gesplit",
    subProduct9:
      "4104 Gelooide huiden en vellen van runderen, zonder haar, ook indien gespleten, doch niet verder bewerkt",
    subProduct10:
      "4107 Leder van runderen, verder bewerkt na looien of korstvorming, met perkament behandeld leer, zonder haar, ook indien gespleten, ander dan leer bedoeld bij post 4114",
    subProduct11: "1801 Cacaobonen, geheel of gebroken, rauw of geroosterd",
    subProduct12: "1802 Cacaodoppen, schillen, vellen en ander cacaoafval",
    subProduct13: "1803 Cacaopasta, ook indien ontvet",
    subProduct14: "1804 Cacaoboter, vet en olie",
    subProduct15:
      "1805 Cacaopoeder, zonder toegevoegde suiker of andere zoetstoffen",
    subProduct16:
      "1806 Chocolade en andere bereidingen voor menselijke consumptie die cacao bevatten",
    subProduct17:
      "0901 Koffie, ook indien gebrand of cafeïnevrij; koffieschillen en -schillen; koffiesurrogaten die koffie bevatten, in welke verhouding dan ook",
    subProduct18: "1207 10 Palmnoten en pitten",
    subProduct19:
      "1511 Palmolie en fracties daarvan, ook indien geraffineerd, doch niet chemisch gewijzigd",
    subProduct20:
      "1513 21 Ruwe palmpit- en babassuolie en fracties daarvan, ook indien geraffineerd, maar niet chemisch gewijzigd",
    subProduct21:
      "1513 29 Palmpit- en babassuolie en fracties daarvan, ook indien geraffineerd, maar niet chemisch gewijzigd (excl. ruwe olie)",
    subProduct22:
      "2306 60 Perskoeken en andere vaste residuen van palmnoten of palmpitten, ook indien fijngemaakt of in pellets, verkregen bij de extractie van palmnoten- of palmpitvetten of -oliën",
    subProduct23:
      "2905 45 Glycerol, met een zuiverheid van 95 % of meer (berekend op basis van het gewicht van het droge product)",
    subProduct24:
      "2915 70 Palmitinezuur, stearinezuur en de zouten en esters daarvan",
    subProduct25:
      "2915 90 Verzadigde acyclische monocarbonzuren en de anhydriden, halogeniden, peroxiden en peroxyzuren daarvan; de gehalogeneerde, gesulfoneerde, genitreerde of nitrosoderivaten daarvan (met uitzondering van mierenzuur, azijnzuur, mono-, di- of trichloorazijnzuren, propionzuur, butaanzuren, pentaanzuren, palmitinezuur, stearinezuur, de zouten en esters daarvan, en azijnzuuranhydride)",
    subProduct26: "3823 11 Stearinezuur, industrieel",
    subProduct27: "3823 12 Oliezuur, industrieel",
    subProduct28:
      "3823 19 Industriële eenwaardige vetzuren; zure oliën afkomstig van raffinage (met uitzondering van stearinezuur, oliezuur en tallolievetzuren)",
    subProduct29: "3823 70 Industriële vetalcoholen",
    subProduct30:
      "4001 Natuurlijk rubber, balata, guttapercha, guayule, chicle en dergelijke natuurlijke gommen, in primaire vormen of in platen, vellen of strippen",
    subProduct31:
      "4005 Samengestelde rubber, niet-gevulkaniseerd, in primaire vormen of in platen, vellen of strippen",
    subProduct32:
      "4006 Niet-gevulkaniseerde rubber in andere vormen (bijvoorbeeld staven, buizen en profielvormen) en voorwerpen (bijvoorbeeld schijven en ringen)",
    subProduct33: "4007 Gevulkaniseerd rubber draad en koord",
    subProduct34:
      "4008 Platen, platen, strippen, staven en profielvormen, van gevulcaniseerde rubber, anders dan harde rubber",
    subProduct35:
      "4010 Transport- of transmissieriemen, van gevulkaniseerd rubber",
    subProduct36: "4011 Nieuwe luchtbanden, van rubber",
    subProduct37:
      "4012 Van een nieuw loopvlak voorziene of gebruikte luchtbanden van rubber; massieve of halfgevulde banden, loopvlakken en velglinten, van rubber",
    subProduct38: "4013 Binnenbanden, van rubber",
    subProduct39:
      "4015 Kledingstukken en kledingtoebehoren (handschoenen, wanten en wanten daaronder begrepen), voor alle doeleinden, van gevulkaniseerd rubber, met uitzondering van hard rubber",
    subProduct40:
      "4016 Andere artikelen van gevulkaniseerde rubber, met uitzondering van harde rubber, niet elders genoemd in hoofdstuk 40",
    subProduct41:
      "4017 Hard rubber (bijvoorbeeld eboniet) in alle vormen, inclusief afval en schroot; artikelen van hard rubber",
    subProduct42: "1201 Sojabonen, ook indien gebroken",
    subProduct43: "1208 10 Sojabonenmeel en -meel",
    subProduct44:
      "1507 Sojaolie en fracties daarvan, ook indien geraffineerd, doch niet chemisch gewijzigd",
    subProduct45:
      "2304 Perskoeken en andere vaste residuen, ook indien gemalen of in pellets, verkregen bij de winning van sojaolie",
    subProduct46:
      "4401 Brandhout, in blokken, in knuppels, in twijgen, in takkenbossen of in dergelijke vormen; hout in spanen of deeltjes; zaagsel, resten en afval, ook indien geperst tot blokken, briketten, pellets of dergelijke vormen",
    subProduct47:
      "4402 Houtskool (schelpen- en notenkool daaronder begrepen), ook indien geagglomereerd",
    subProduct48:
      "4403 Ruw hout, ook indien ontdaan van bast of spint, of vierkant bezaagd",
    subProduct49:
      "4404 Hoepelhout; gespleten polen; stapels, piketten en palen van hout, puntig maar niet in de lengte gezaagd; houten stokken, grof afgesneden maar niet gedraaid, gebogen of op andere wijze bewerkt, geschikt voor de vervaardiging van wandelstokken, paraplu's, gereedschapsstelen en dergelijke; spaanhout en dergelijke",
    subProduct50: "4405 Houtwol; houtmeel",
    subProduct51: "4406 Spoor- of trambielzen (dwarsliggers) van hout",
    subProduct52:
      "4407 Hout, overlangs gezaagd of afgestoken, dan wel gesneden of geschild, ook indien geschaafd, geschuurd of in de lengte verbonden, met een dikte van meer dan 6 mm",
    subProduct53:
      "4408 Fineerplaten (die verkregen door het snijden van gelamineerd hout daaronder begrepen), voor multiplex of voor ander soortgelijk gelamineerd hout en ander hout, overlangs gezaagd, gesneden of geschild, ook indien geschaafd, geschuurd, met lasverbinding of met kopsverbinding, met een dikte van niet groter dan 6 mm",
    subProduct54:
      "4409 Hout (strips en friezen voor parketvloeren daaronder begrepen, niet gemonteerd) met een ononderbroken vorm (tong, gegroefd, gewelfd, afgeschuind, met V-verbinding, kralen, gevormd, afgerond en dergelijke) langs de randen, uiteinden of vlakken, ook al dan niet niet geschaafd, geschuurd of koplas",
    subProduct55:
      "4410 Spaanplaat, georiënteerde strengplaat (OSB) en soortgelijke plaat (bijvoorbeeld waferboard) van hout of van andere houtachtige materialen, ook indien geagglomereerd met harsen of andere organische bindmiddelen",
    subProduct56:
      "4411 Vezelplaat van hout of van andere houtachtige materialen, ook indien gebonden met harsen of andere organische stoffen",
    subProduct57:
      "4412 Multiplex, gefineerde panelen en soortgelijk gelamineerd hout",
    subProduct58:
      "4413 Verdicht hout, in blokken, platen, stroken of profielvormen",
    subProduct59:
      "4414 Houten lijsten voor schilderijen, foto's, spiegels of soortgelijke voorwerpen",
    subProduct60:
      "4415 Pakkisten, dozen, kratten, trommels en dergelijke verpakkingen, van hout; kabeltrommels van hout; pallets, boxpallets en andere laadborden, van hout;",
    subProduct61:
      "opstaande randen van hout (exclusief verpakkingsmateriaal dat uitsluitend wordt gebruikt als verpakkingsmateriaal voor het ondersteunen, beschermen of vervoeren van een ander op de markt gebracht product)",
    subProduct62:
      "4416 Vaten, vaten, kuipen en andere kuipersproducten, alsmede delen daarvan, van hout, duigen daaronder begrepen",
    subProduct63:
      "4417 Gereedschappen, gereedschapslichamen, gereedschapstelen, bezem- of borstellichamen en stelen, van hout; laars- of schoenleesten en bomen, van hout",
    subProduct64:
      "4418 Schrijn- en timmerwerk voor bouwwerken, met inbegrip van panelen met cellenstructuur, samengestelde vloerpanelen, dakspanen en dakspanen",
    subProduct65: "4419 Servies en keukengerei, van hout",
    subProduct66:
      "4420 Houten inlegwerk en ingelegd hout; kisten en etuis voor sieraden of bestek, en dergelijke artikelen, van hout; beeldjes en andere versieringen, van hout; houten meubelstukken die niet onder hoofdstuk 94 vallen",
    subProduct67: "4421 Andere houtwaren",
    subProduct68:
      "Pulp en papier van de hoofdstukken 47 en 48 van de gecombineerde nomenclatuur, met uitzondering van producten op basis van bamboe en teruggewonnen producten (afval en schroot)",
    subProduct69:
      "49 Gedrukte boeken, kranten, afbeeldingen en andere producten van de grafische industrie, manuscripten, typoscripten en plattegronden, van papier",
    subProduct70:
      "9401 Zitbanken (andere dan die bedoeld bij post 9402), ook indien om te bouwen tot bedden, alsmede delen daarvan, van hout",
    subProduct71:
      "9403 30 , 9403 40 , 9403 50 , 9403 60 en 9403 91 Houten meubelen en delen daarvan",
    subProduct72: "9406 10 Geprefabriceerde gebouwen van hout",

    selectStatus: "Status selecteren",

    pleaseSelectAtLeastOneSource: "Selecteer alstublieft ten minste één bron.",
    invalidFileFormatPleaseUploadValidFile:
      "Ongeldig bestandsformaat. Upload alstublieft een .xml, .kml of .geojson bestand.",
    pleaseUploadAValidFile: "Upload alstublieft een geldig bestand.",
    fileUploadedDuccessfully: "Bestand succesvol geüpload!",
    anErrorOccured: "Er is een fout opgetreden.",
    successfullyUpdatedDefaultFarmArea:
      "Standaard landbouwgebied succesvol bijgewerkt.",
    pleaseAddProductionPlacesData:
      "Voeg alstublieft productieplaatsgegevens toe.",
    failedToFetchSettings: "Instellingen ophalen mislukt.",
    updatedDueDiligenceReport:
      "Rapport voor zorgvuldigheidsonderzoek bijgewerkt.",
    updatedDueDiligenceStatus:
      "De status van de Due Diligence is succesvol bijgewerkt.",
    failedToWriteDeforestationDataToBlockchain:
      "Mislukt om ontbossingsgegevens op de blockchain te schrijven, probeer het opnieuw.",
    countryIsRequired: "Land is verplicht",
    dueDiligenceReportsInfo:
      "Gedetailleerde documentatie die de bevindingen en resultaten van het zorgvuldigheidsonderzoek samenvat. Deze rapporten bieden inzicht in de uitgevoerde beoordeling, inclusief eventuele geïdentificeerde risico's, nalevingsstatus en aanbevelingen voor mitigatie of verbetering.",
    listOfFarmsTT:
      "Een uitgebreide weergave van boerderijen, inclusief informatie zoals de productielocatie, de naam van de producent, het land van exploitatie, het landoppervlak in hectare, het type landbouwactiviteiten, beoordelingen met betrekking tot ontbossing en evaluaties van potentiële risico's die verband houden met de boerderijactiviteiten.",

    mutiStepHeadingLable: "Maak een nieuwe stap voor elke subtitel",
    multiStepQuestion1: "Maak een nieuwe stap na",
    questions: "vragen",
    questionsInfo: "Aantal vragen in elke fase van een meerstapsbeoordeling.",

    loadingPleaseWait: "Laden... Even geduld aub",
    existingProductionPlacesTT:
      "Toont een lijst met bestaande productieplaatsen, samen met details zoals de naam van de producent, land, gebied, type en beoordelingsstatus.",
    successfullyGeneratedEUDRDeforestationStatus:
      "De EUDR-ontbossingsstatus is succesvol gegenereerd.",
    riskAssessmentAndMitigationTT:
      "Het identificeren van potentiële risico's en het implementeren van strategieën om hun impact of waarschijnlijkheid van optreden te minimaliseren. Dit omvat het evalueren van gevaren, het analyseren van hun mogelijke gevolgen en het ontwikkelen van plannen om ze effectief aan te pakken of te mitigeren.",
    eudrRefNoTT:
      "Een unieke identificatiecode die aan elk due diligence-rapport wordt toegewezen, waardoor het volgen en controleren van naleving binnen het kader van de Europese Unie Ontbossingsverordening (EUDR) wordt vergemakkelijkt.",

    supplierDataTT: "Informatie over de leverancier.",
    operatorDataTT: "Informatie over de operator.",
    reportSummaryTT: "Korte samenvatting van het rapport.",
    totalNoOfGeofencePolygon: "Totaal Aantal Geofence Polygonen",
    totalNoOfGeofencePolygonTT: "Totaal aantal geofence polygonen.",
    totalNoOfGeofencePoint: "Totaal Aantal Geofence Punten",
    totalNoOfGeofencePointTT: "Totaal aantal geofence punten.",
    totalNoOfFarmsTT: "Totaal aantal boerderijen.",
    totalAreaFinalReport: "Totale Oppervlakte (ha)",
    totalNoOfDeforestationTT: "Totaal aantal ontbossingsbeoordelingen.",
    totalNoOfHighDeforestationTT:
      "Totaal aantal boerderijen met hoge ontbossing.",
    totalNoOfRiskAssessments: "Totaal Aantal Risicobeoordelingen",
    totalNoOfRiskAssessmentsTT: "Totaal aantal risicobeoordelingen.",
    productDetail: "Productdetails",
    productDetailTT: "Informatie over het product.",
    productTT:
      "Naam van het product. Verwijst naar een tastbaar item of handelswaar geproduceerd, vervaardigd of verhandeld door een bedrijf of organisatie, vaak gecategoriseerd op basis van het type, de kenmerken of het doel.",
    productDescription: "Productbeschrijving",
    productDescriptionTT:
      "Geeft een tekstuele uitleg of samenvatting van de kenmerken, functies of eigenschappen van een product, met als doel gebruikers of klanten te informeren over de aard of functionaliteit ervan.",
    netMass: "Netto Massa",
    netMassTT:
      "Geeft het gewicht van een product of item aan, meestal exclusief het gewicht van de verpakking of andere bijbehorende materialen, vaak uitgedrukt in massaeenheden zoals kilogrammen of ponden.",
    volume: "Volume",
    volumeTT:
      "Verwijst naar de hoeveelheid ruimte die door een product of stof wordt ingenomen, meestal gemeten in kubieke eenheden zoals kubieke meters of kubieke voeten, gebruikt om capaciteit of hoeveelheid in driedimensionale ruimte te kwantificeren.",
    scientificName: "Wetenschappelijke Naam",
    scientificNameTT:
      "Taxonomische naam van een organisme die bestaat uit het geslacht en de soort, bijv. Coffea Arabica, Theobroma cacao L.",
    commonNameTT:
      "Een naam gebaseerd op de dagelijkse taal van het dagelijks leven, bijvoorbeeld Cacao, Koffie.",

    successfullyUploadedToTheBlockchain:
      "Succes! Het EUDR Due Diligence Rapport is succesvol geüpload naar de Blockchain.",
    complianceRiskWarning: "Waarschuwing voor Nalevingsrisico",
    issueIdentifiedOnFarms:
      "Er zijn problemen geïdentificeerd op enkele boerderijen die aandacht vereisen voordat je doorgaat naar de volgende stap. Je kunt ervoor kiezen om deze problemen nu aan te pakken of doorgaan naar de volgende stap en ze later oplossen.",
    blockchainDescs: [
      "Rapport wordt naar de blockchain geüpload, even geduld...",
      "Uw Due Diligence-rapport wordt naar de blockchain geüpload. U wordt doorgestuurd naar de lijst met Due Diligence-rapporten om de status te bekijken.",
    ],
    reportDownloadedSuccessfully: "Rapport succesvol gedownload!",
    operatorDecleration: "Verklaring van de Operator",
    supplierDecleration: "Verklaring van de Leverancier",
    fRinternalReferenceNumberTT:
      "Een intern referentienummer is een unieke identificatie die aan een due diligence-rapport binnen het systeem is toegewezen.",
    deleteProductionPlaceData: "Verwijder Productieplaatsgegevens",
    areYouSureYouWantToContinueThisAction:
      "Weet je zeker dat je deze actie wilt voortzetten?",
    noAssessment: "Geen beoordeling",
    operatorDeclerationTT: "Verklaringsverklaring van de exploitant.",
    supplierDeclerationTT: "Verklaringsverklaring leverancier.",
    totalNoOfDeforestation: "Totaal aantal ontbossingen",

    blockchainVerification: "Blockchain-verificatie",
    scanQrBlockchain:
      "Scan deze QR-code om het EUDR Due Diligence-rapport op de blockchain te bekijken.",
    downloadQrCode: "Qr-code downloaden",
    eudrPublicReport: "Dimitra EUDR Due Diligence openbaar rapport",
    scanQrEudr:
      "Scan deze QR-code om het EUDR Due Diligence-rapport op het openbare internet te bekijken.",
    viewReportForPublic: "Klik hier om het rapport voor publiek te bekijken",
    viewReportOnBlockChain:
      "Klik hier om het rapport op de blockchain te bekijken",

    declarationMissing: "Verklaring Ontbreekt",
    removeRiskFarms: "VERWIJDER RISICOVOLLE BOERDERIJEN",
    disregardRiskDocument: "NEGEER RISICOVOLLE BOERDERIJEN",
    attachRiskMitigationDocumentForNonCompliantFarms: "VOEG RISICOMITIGATIEDOCUMENT TOE VOOR ALLE NIET-NALEVING BOERDERIJEN",
    uploadMitigationDocumentForNonCompliantFarms: `Het uploaden van een risicomitigatiedocument voor alle niet-naleving boerderijen zal de status van boerderijen met "Mitigatie Vereist" veranderen naar "Handmatig Gemitigeerd".`,
    disregardFarmWithIssuesTitle: "Abaikan Pertanian",
    disregardFarmWithIssuesMessage: "Dengan memilih 'Abaikan,' status penilaian risiko yang hilang untuk pertanian tidak akan dipertimbangkan dalam laporan ini. Pertanian akan tetap menjadi bagian dari laporan, tetapi penilaian yang tertunda tidak akan mempengaruhi status kepatuhan. Harap konfirmasi bahwa Anda ingin melanjutkan.",
    removeRiskFarmTitle: "Hapus Pertanian",
    removeRiskFarmMessage: "Dengan memilih 'Hapus,' pertanian dengan penilaian risiko yang hilang akan dihapus dari laporan. Harap konfirmasi bahwa Anda ingin melanjutkan.",

    fileName: "Bestandsnaam",
    dateAndTime: "Datum en tijd",
    downloadProgressStatus: "Status van downloadvoortgang",
    downloadHistory: "Downloadgeschiedenis",
    downloaded: "Gedownload",
    inprogress: "Bezig",
    failed: "Mislukt",
    showAllDownloads: "Alle downloads weergeven",
    inProgress: "Bezig",
    downloadCompleted: "Download voltooid",
    downloadFailed: "Download mislukt",
    errorDeletingItem: "Het item kon niet worden verwijderd. Probeer het later opnieuw.",
    anErrorOccuredPlsTryAgain: "Er is iets misgegaan. Probeer het opnieuw.",
    invalidData: "De verstrekte gegevens zijn ongeldig. Controleer en probeer het opnieuw.",
    fileIsReady: "Het bestand is klaar voor gebruik",
    invalidFilePathOrUrl: "Het bestandspad of de URL is ongeldig.",
    errorDownloadingFile: "Er was een probleem bij het downloaden van het bestand. Probeer het opnieuw.",
    downloadInitiated: "Download gestart",
    beingDownloaded: "wordt nu gedownload. Geschatte tijd",

    multiStepSurveyDetails: "Op basis van het aantal vragen in een stap worden alle vragen in de enquête gegroepeerd en weergegeven in stappen. Deze configuratie is echter alleen beschikbaar voordat vragen of subkoppen worden toegevoegd. Zodra een vraag of subkop is toegevoegd, wordt de Multi-Step-configuratie automatisch uitgeschakeld. Verwijder eventuele vragen of subkoppen om deze optie opnieuw in te schakelen.",
    estimatedTime: "Geschatte tijd",
    tryAgain: "Probeer het opnieuw"


  },
  diligenceGuide: {
    guide: "Gids",
    downloadPdfManual: "PDF-handleiding downloaden",
    watchDemoVideo: "Bekijk Demovideo",
    viewManualOnWeb: "Bekijk Handleiding op Web",
  },
  welcomeScreenDiligenceGuide: {
    title: "Jouw Essentiële Gids Hub",
    description: `Ontdek onze EUDR Due Diligence System Hulpgidsen pagina voor essentiële
          bronnen zoals PDF-handleidingen, videotutorials en webgebaseerde
          assistentie. Geef jezelf de kracht om het platform efficiënt te navigeren
          en optimaliseer je workflow.`,
    continueToTheDueDiligenceSystem: "Doorgaan naar het Due Diligence Systeem",
  },
  containerTypes: {
    standardDry: "Standaard Droge Container (20ft, 40ft)",
    highCube: "Hoge Kubus Container",
    openTop: "Open Top Container",
    flatRack: "Flat Rack Container",
    refrigerated: "Gekoelde Container (Reefer)",
    tank: "Tankcontainer",
    ventilated: "Geventileerde Container",
    insulated: "Geïsoleerde Container",
    platform: "Platformcontainer",
    halfHeight: "Halfhoge Container",
    bulk: "Bulkcontainer",
  },
  assessmentStatus:{
    riskAssessmentSummary: "Risicobeoordelingssamenvatting",
    riskAssessmentSummaryTT: "Risicobeoordelingssamenvatting",
    totalNoOfFarms: "Totaal Aantal Boerderijen",
    assessmentsCompleted: "Beoordelingen Voltooid",
    assessmentsPending: "Beoordelingen In Behandeling",
    requiredMitigation: "Vereiste Mitigatie",
  }
};
